// extracted by mini-css-extract-plugin
module.exports = {"products_nav":"App_products_nav__39aM6"};